var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRightSmallArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.487 5a.4.4 0 01-.104.272L1.118 9.867a.338.338 0 01-.503 0 .405.405 0 010-.542L4.628 5 .614.673a.405.405 0 010-.541.338.338 0 01.502 0l4.267 4.599c.07.075.104.173.104.27z",
    fill: "#10B1D7"
  })));
}
export default SvgIconRightSmallArrow;